// extracted by mini-css-extract-plugin
module.exports = {"container":"input_container__2CIC_"};